import { X, Save } from "lucide-react";

export const cls = "w-full h-10 px-3 rounded-lg border border-slate-200 bg-white text-[13px] outline-none focus:border-hocp-navy transition";

export function Fld({ label, children, full, hint }) {
  return (
    <label className={`block ${full ? "col-span-2" : ""}`}>
      <div className="text-[11.5px] text-slate-500 mb-1 font-medium">{label}</div>
      {children}
      {hint && <div className="text-[11px] text-slate-400 mt-1">{hint}</div>}
    </label>
  );
}

export function Modal({ title, children, onClose, size = "2xl" }) {
  const sizes = { md: "max-w-md", lg: "max-w-lg", xl: "max-w-xl", "2xl": "max-w-2xl", "3xl": "max-w-3xl", "4xl": "max-w-4xl" };
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
      <div className={`bg-white rounded-2xl w-full ${sizes[size]} max-h-[92vh] flex flex-col`}
           onClick={e=>e.stopPropagation()} data-testid="wae-modal">
        <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between shrink-0">
          <h3 className="font-display text-[16px] font-semibold text-hocp-navy">{title}</h3>
          <button onClick={onClose} data-testid="wae-modal-close"
                  className="p-2 rounded-lg hover:bg-slate-100">
            <X className="w-4 h-4 text-slate-500"/>
          </button>
        </div>
        <div className="p-5 overflow-y-auto flex-1">{children}</div>
      </div>
    </div>
  );
}

export function Footer({ onClose, onSubmit, saving, submitLabel = "Confirm", testid }) {
  return (
    <div className="pt-4 mt-4 border-t border-slate-100 flex justify-end gap-2 -mx-5 -mb-5 px-5 py-3 bg-slate-50">
      <button onClick={onClose} className="h-9 px-3.5 rounded-lg text-slate-600 text-[13px] hover:bg-slate-100">Cancel</button>
      <button onClick={onSubmit} disabled={saving} data-testid={testid}
              className="h-9 px-4 rounded-lg bg-hocp-gold text-hocp-eerie text-[13px] font-medium disabled:opacity-60 inline-flex items-center gap-2">
        <Save className="w-4 h-4"/> {saving ? "Saving…" : submitLabel}
      </button>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, msg, cta, testid }) {
  return (
    <div className="p-12 text-center" data-testid={testid || "wae-empty"}>
      {Icon && <Icon className="w-12 h-12 mx-auto text-slate-300 mb-3" strokeWidth={1.5}/>}
      {title && <div className="font-display text-[15px] font-semibold text-hocp-navy mb-1">{title}</div>}
      <div className="text-[13px] text-slate-500">{msg}</div>
      {cta && <div className="mt-4">{cta}</div>}
    </div>
  );
}
